
import {

    ufBodyTemplate,
    cidadeBodyTemplate,
    TrocaBody,
    ReabBody,
    CremaçãoBody,
    carenciaSemProBodyTemplate,
    valorBaseMensalidade,
    valorDescontoMensalidadeCartao,
    valorDescontoMensalidadeBoleto,
    valorDescontoMensalidadeEscelsa
} from '../../../modulos/function/tabelaPreco';
import { NovoBody,ProdutoDescricaoBody,ProdutoDescricaoSubGrupo } from '../../../modulos/function/tabelaEdicaoPreco';

export const colunasTabelaPrecoVendedor = {
    adesao: [['Produto.descricao','Plano',ProdutoDescricaoBody,{
        backgroundColor: '#B0E0E6',
        height: '60px' }],
    ['cidade','Cidade',cidadeBodyTemplate,{ backgroundColor: '#B0E0E6' }],

    ['UF','UF',ufBodyTemplate,{
        backgroundColor: '#B0E0E6',
        height: '60px' }],
    ['carencia','Carência',carenciaSemProBodyTemplate,{ backgroundColor: '#e4d0e3' }],
    ['adesao_novo','Novo',NovoBody,{ backgroundColor: '#e4d0e3' }],
    ['adesao_troca','Troca',TrocaBody,{ backgroundColor: '#e4d0e3' }],
    ['adesao_reab','Reabilitação',ReabBody,{ backgroundColor: '#e4d0e3' }],
    ['adesao_cremacao','Cremação',CremaçãoBody,{ backgroundColor: '#e4d0e3' }]],
    mensalidade: [
        ['Produto.descricao','Plano',ProdutoDescricaoBody,{
            backgroundColor: '#B0E0E6',
            height: '60px' }],
        ['subgrupo','SubGrupo',ProdutoDescricaoSubGrupo,{
            backgroundColor: '#B0E0E6',
            height: '60px' }],
        ['cidade','Cidade',cidadeBodyTemplate,{ backgroundColor: '#B0E0E6' }],

        ['UF','UF',ufBodyTemplate,{
            backgroundColor: '#B0E0E6',
            height: '60px' }],
        ['valorBase','Valor Base',valorBaseMensalidade,{ backgroundColor: '#e4d0e3' }],
        ['valorDoDescontoCartao','Valor e vigência do desconto cartão',valorDescontoMensalidadeCartao,{ backgroundColor: '#e4d0e3' }],
        ['valorDoDescontoBoleto','Valor e vigência do desconto boleto',valorDescontoMensalidadeBoleto,{ backgroundColor: '#e4d0e3' }],
        ['valorDoDescontoEscelsa','Valor e vigência do desconto Escelsa',valorDescontoMensalidadeEscelsa,{ backgroundColor: '#e4d0e3' }]
    ]
};
